import AdvertiserGroup from './AdvertiserGroup';

export default AdvertiserGroup;
